import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getAffiliatedClubBySlug, affiliatedClubs } from '../data/affiliatedClubs';
import { PageBanner } from '../components/PageBanner';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { KeyDetailsBlock } from '../components/KeyDetailsBlock';
import { RelatedPages } from '../components/RelatedPages';
export function AffiliatedClubDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const club = slug ? getAffiliatedClubBySlug(slug) : undefined;
  if (!club) return <Navigate to="/affiliated-clubs" replace data-id="element-555" />;
  const otherClubs = affiliatedClubs.filter(c => c.id !== club.id).slice(0, 3).map(c => ({
    title: c.name,
    image: c.image,
    link: `/affiliated-clubs/${c.id}`
  }));
  return <div className="w-full bg-club-canvas pb-24" data-id="element-556">
      <PageBanner title={club.name} eyebrow="Affiliated Club" image={club.image} data-id="element-557" />

      <div className="max-w-7xl mx-auto px-4 mt-8" data-id="element-558">
        <Breadcrumbs items={[{
        label: 'Affiliated Clubs',
        path: '/affiliated-clubs'
      }, {
        label: club.name
      }]} data-id="element-559" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mt-8" data-id="element-560">
          <div className="lg:col-span-2 space-y-12" data-id="element-561">
            <section data-id="element-562">
              <h2 className="text-3xl mb-6" data-id="element-563">About {club.name}</h2>
              <p className="text-lg text-club-ink/80 leading-relaxed" data-id="element-564">
                {club.longDesc}
              </p>
            </section>
          </div>

          <div className="space-y-8" data-id="element-565">
            <KeyDetailsBlock details={club.keyDetails} data-id="element-566" />

            <div className="bg-white p-8 border border-club-border rounded-sm text-center" data-id="element-567">
              <h3 className="font-serif text-2xl mb-4 text-club-green" data-id="element-568">
                Request Introduction
              </h3>
              <p className="text-sm text-club-ink/70 mb-6" data-id="element-569">
                A Letter of Introduction is required prior to visiting any
                affiliated club.
              </p>
              <button className="btn-primary w-full" data-id="element-570">Request Letter</button>
            </div>
          </div>
        </div>

        <RelatedPages title="Other Affiliated Clubs" pages={otherClubs} data-id="element-571" />
      </div>
    </div>;
}